// src/services/categoryService.jsx
import http from "./http";

/* --------------------------------
   ADD CATEGORY
-------------------------------- */
export const addCategory = async (payload) => {
  const res = await http.post("addFPCategory", {
    name: payload.name,
    description: payload.description,
  });
  return res.data;
};

/* --------------------------------
   UPDATE CATEGORY
-------------------------------- */
export const updateCategory = async (id, payload) => {
  const res = await http.post("updateFPCategory", {
    id,
    name: payload.name,
    description: payload.description,
  });
  return res.data;
};

/* --------------------------------
   GET ALL CATEGORIES
-------------------------------- */
export const getCategories = async () => {
  const res = await http.post("getFPCategories", {});
  return res.data;
};

/* --------------------------------
   ✅ GET SINGLE CATEGORY (EDIT)
   API: GET get_single_fpcategory?id=14
-------------------------------- */
export const getCategoryById = async (id) => {
  const res = await http.get(`get_single_fpcategory?id=${id}`);
  return res.data;
};

/* --------------------------------
   DELETE CATEGORY
-------------------------------- */
export const deleteCategory = async (id) => {
  const res = await http.post("deleteFPCategory", { id });
  return res.data;
};
